import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const BorderLinearProgressSafe = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

const BorderLinearProgressWarn = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#ffa31a",
  },
}))(LinearProgress);

const BorderLinearProgressLimit = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#ff1a1a",
  },
}))(LinearProgress);

function LinearProgressWithLabel({ ratio }) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        {ratio < 80 && (
          <BorderLinearProgressSafe variant="determinate" value={ratio} />
        )}
        {(ratio >= 80 && ratio < 90) && (
          <BorderLinearProgressWarn variant="determinate" value={ratio} />
        )}
        {ratio >= 90 && (
          <BorderLinearProgressLimit variant="determinate" value={
            ratio <= 100 ? ratio : 100
          } />
        )}
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {ratio}%
        </Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

export default function LinearWithValueLabel({ ratio }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgressWithLabel ratio={ratio} />
    </div>
  );
}
